<template>
  <div class="tutorial2-page">
    <div class="page-heading">
      <div>
        <h2>{{ isEdit ? '编辑教程' : '新建教程' }}</h2>
        <p>完善教程信息并发布给用户查看</p>
      </div>
      <el-button size="small" plain icon="el-icon-arrow-left" @click="$router.push('/user2/upload_tutorial')">
        返回教程设置
      </el-button>
    </div>

    <section class="tutorial-panel">
      <el-form ref="form" :model="form" label-width="88px" class="tutorial-form">
        <el-form-item label="教程标题" required>
          <el-input v-model="form.title" placeholder="请输入教程标题" maxlength="100" show-word-limit></el-input>
        </el-form-item>

        <el-form-item label="教程标签" required>
          <el-select v-model="form.tags" multiple placeholder="选择标签" @focus="loadTypes" class="full-width">
            <el-option v-for="item in tagOptions" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="公开状态">
          <el-switch v-model="form.status" :active-value="1" :inactive-value="0" active-text="公开"
            inactive-text="私密"></el-switch>
        </el-form-item>

        <el-form-item label="教程描述">
          <el-input v-model="form.description" type="textarea" :rows="4" placeholder="请描述教程内容（可选）"
            maxlength="500" show-word-limit></el-input>
        </el-form-item>

        <el-form-item label="内容类型" required>
          <div class="mode-switch">
            <button type="button" :class="{ active: mode === 'video' }" @click="switchMode('video')">视频教程</button>
            <button type="button" :class="{ active: mode === 'images' }" @click="switchMode('images')">图文教程</button>
          </div>
        </el-form-item>

        <el-form-item label="教程封面">
          <div v-if="coverUrl" class="current-cover">
            <el-image :src="coverUrl" fit="cover" class="cover-image"></el-image>
            <div class="file-status">
              <span><i class="el-icon-picture"></i> 当前封面</span>
              <el-button type="text" size="mini" @click="replaceCover">替换封面</el-button>
            </div>
          </div>
          <cosupload v-if="!coverUrl" ref="cosupload_cover" :image_mode="true" upload_class="tutorial"
            :limit_url="1" :mb="5" :uploadkey="uploadkey" @upload-success="handleCoverSuccess"></cosupload>
        </el-form-item>

        <el-form-item v-if="mode === 'video'" label="教程视频">
          <div v-if="localVideoUrl && !showUpload" class="current-video">
            <video :src="localVideoUrl" controls></video>
            <div class="file-status">
              <span><i class="el-icon-video-play"></i> 当前视频</span>
              <el-button type="text" size="mini" @click="showUpload = true">替换视频</el-button>
            </div>
          </div>
          <cosupload v-if="showUpload" ref="cosupload" upload_class="tutorial" :limit_url="1" :mb="10"
            :uploadkey="uploadkey" @upload-success="handleUploadSuccess"></cosupload>
          <div v-if="newVideoUrl" class="new-video">
            <video :src="newVideoUrl" controls></video>
            <div><i class="el-icon-success"></i> 新视频已上传</div>
          </div>
        </el-form-item>

        <el-form-item v-if="mode === 'images'" label="教程图片">
          <div v-if="form.images.length > 0" class="image-list">
            <div v-for="(img, idx) in form.images" :key="idx" class="image-item" draggable="true"
              @dragstart="dragStart(idx, $event)" @dragover.prevent="dragOver(idx, $event)"
              @drop="drop(idx, $event)" @dragend="dragEnd">
              <el-image :src="img" fit="cover"></el-image>
              <button type="button" class="delete-image" title="删除" @click="deleteImage(idx)">
                <i class="el-icon-delete"></i>
              </button>
            </div>
          </div>
          <cosupload ref="cosupload_images" :image_mode="true" upload_class="tutorial" :limit_url="20" :mb="5"
            :uploadkey="uploadkey" @upload-success="handleImagesSuccess"></cosupload>
        </el-form-item>

        <el-form-item class="form-actions">
          <el-button type="primary" :loading="saving" @click="save">{{ saving ? '保存中...' : '保存' }}</el-button>
          <el-button @click="$router.push('/user2/upload_tutorial')">取消</el-button>
        </el-form-item>
      </el-form>
    </section>
  </div>
</template>

<script>
import cosupload from '@/components/common/cosupload.vue'

export default {
  name: 'User2TutorialEdit',
  components: { cosupload },
  data() {
    return {
      mode: 'video',
      dragIndex: null,
      form: { title: '', tags: [], description: '', status: 1, images: [] },
      tutorialTypes: [],
      typesLoaded: false,
      coverUrl: '',
      localVideoUrl: '',
      newVideoUrl: '',
      uploadkey: '',
      showUpload: false,
      saving: false
    }
  },
  computed: {
    isEdit() {
      return !!this.$route.query.id
    },
    tagOptions() {
      return this.tutorialTypes.filter(function (item) { return item !== '全部' })
    }
  },
  methods: {
    switchMode(value) {
      this.mode = value
    },
    loadTypes() {
      if (this.typesLoaded) return
      this.$ajax.get('qhy/app/get_tutorial_types').then(res => {
        if (res.data.status == 200) {
          this.tutorialTypes = res.data.data || []
          this.typesLoaded = true
        }
      })
    },
    handleUploadSuccess(data) {
      this.newVideoUrl = data.url
    },
    handleCoverSuccess(data) {
      this.coverUrl = data.url
    },
    handleImagesSuccess(data) {
      if (data.url && this.form.images.indexOf(data.url) === -1) this.form.images.push(data.url)
    },
    replaceCover() {
      this.coverUrl = ''
      this.$nextTick(() => {
        if (this.$refs.cosupload_cover) this.$refs.cosupload_cover.clear_url()
      })
    },
    deleteImage(index) {
      this.form.images.splice(index, 1)
    },
    dragStart(index, event) {
      this.dragIndex = index
      event.dataTransfer.effectAllowed = 'move'
    },
    dragOver(index, event) {
      if (this.dragIndex === null || this.dragIndex === index) return
      event.dataTransfer.dropEffect = 'move'
    },
    drop(index) {
      if (this.dragIndex === null || this.dragIndex === index) return
      var item = this.form.images.splice(this.dragIndex, 1)[0]
      this.form.images.splice(index, 0, item)
      this.dragIndex = null
    },
    dragEnd() {
      this.dragIndex = null
    },
    save() {
      if (!this.form.title.trim()) {
        this.$msg.warning('请输入教程标题')
        return
      }

      var videoUrl = ''
      if (this.mode === 'video') {
        videoUrl = this.newVideoUrl || this.localVideoUrl
        if (!videoUrl && this.$refs.cosupload) {
          var urls = this.$refs.cosupload.get_urls(1)
          if (urls.status != 100 && urls.length > 0) videoUrl = urls[0].url
        }
        if (!videoUrl) {
          this.$msg.warning('请先上传视频')
          return
        }
      }

      if (this.mode === 'video') {
        this.form.images = []
      } else {
        this.localVideoUrl = ''
        this.newVideoUrl = ''
      }

      this.saving = true
      var data = {
        title: this.form.title,
        tags: this.form.tags,
        status: this.form.status,
        description: this.form.description,
        cover: this.coverUrl
      }
      if (this.mode === 'video') {
        data.video = videoUrl
      } else {
        var images = [].concat(this.form.images)
        if (this.$refs.cosupload_images) {
          var imageUrls = this.$refs.cosupload_images.get_urls(1)
          if (imageUrls.status != 100) {
            for (var i = 0; i < imageUrls.length; i++) {
              if (images.indexOf(imageUrls[i].url) === -1) images.push(imageUrls[i].url)
            }
          }
        }
        data.images = images
      }
      if (this.isEdit) data.id = this.$route.query.id

      this.$ajax.post('qhy/app/tutorial_update', data, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(res => {
        if (res.data.status == 200) {
          this.$msg.success('保存成功')
          var newId = res.data.data && res.data.data.id
          if (newId) {
            this.$router.replace('/user2/tutorial_edit?id=' + newId)
          } else {
            this.$router.push('/user2/upload_tutorial')
          }
        } else {
          this.$msg.error(res.data.msg || '保存失败')
        }
        this.saving = false
      }).catch(() => {
        this.$msg.error('保存失败，请稍后重试')
        this.saving = false
      })
    },
    loadDetail() {
      this.$ajax.get('qhy/app/tutorial_info?id=' + this.$route.query.id).then(res => {
        if (res.data.status == 200) {
          var data = res.data.data || {}
          this.form.title = data.title || ''
          this.form.tags = data.tags ? (typeof data.tags === 'string' ? JSON.parse(data.tags) : data.tags) : []
          this.form.status = data.status != null ? data.status : 1
          this.form.description = data.description || ''
          this.localVideoUrl = data.video || ''
          this.coverUrl = data.cover || ''
          this.form.images = data.images ? (typeof data.images === 'string' ? JSON.parse(data.images) : data.images) : []
          if (this.form.images.length > 0) {
            this.mode = 'images'
            this.showUpload = false
          } else {
            this.mode = 'video'
            this.showUpload = !this.localVideoUrl
          }
        } else {
          this.$msg.error(res.data.msg || '加载失败')
        }
      }).catch(() => {
        this.$msg.error('加载失败')
      })
    }
  },
  created() {
    if (this.isEdit) this.loadDetail()
    else this.showUpload = true
  }
}
</script>

<style scoped>
.tutorial2-page {
  max-width: 1180px;
  margin: 0 auto;
  color: #1e293b;
}

.page-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
}

.page-heading h2 {
  margin: 0;
  font-size: 24px;
  color: #0f172a;
}

.page-heading p {
  margin: 8px 0 0;
  color: #94a3b8;
  font-size: 13px;
}

.tutorial-panel {
  padding: 24px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);
}

.full-width {
  width: 100%;
}

.mode-switch {
  display: inline-flex;
  padding: 3px;
  background: #eef2f7;
  border-radius: 20px;
}

.mode-switch button {
  min-width: 92px;
  padding: 8px 16px;
  color: #64748b;
  background: transparent;
  border: 0;
  border-radius: 18px;
  cursor: pointer;
  font-size: 13px;
}

.mode-switch button.active {
  color: #fff;
  background: #1a73e8;
}

.current-cover,
.current-video {
  max-width: 520px;
}

.cover-image {
  display: block;
  width: 220px;
  height: 130px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.current-video video,
.new-video video {
  display: block;
  width: 100%;
  max-height: 300px;
  background: #000;
  border-radius: 8px;
}

.file-status {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 6px;
  color: #64748b;
  font-size: 13px;
}

.new-video {
  margin-top: 10px;
  color: #16a34a;
  font-size: 13px;
}

.image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 10px;
}

.image-item {
  position: relative;
  padding: 2px;
  border: 2px solid transparent;
  border-radius: 9px;
  cursor: grab;
}

.image-item:hover {
  border-color: #409eff;
}

.image-item .el-image {
  display: block;
  width: 110px;
  height: 76px;
  border-radius: 6px;
}

.delete-image {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 22px;
  height: 22px;
  padding: 0;
  color: #fff;
  background: #f56c6c;
  border: 0;
  border-radius: 50%;
  cursor: pointer;
}

.form-actions {
  margin-bottom: 0;
}

@media (max-width: 640px) {
  .tutorial2-page {
    padding: 0 2px;
  }

  .page-heading {
    align-items: flex-start;
    margin-bottom: 14px;
  }

  .page-heading h2 {
    font-size: 20px;
  }

  .tutorial-panel {
    padding: 16px 12px;
    border-radius: 12px;
  }

  .tutorial-form .el-form-item__label {
    float: none;
    display: block;
    width: auto !important;
    padding: 0 0 6px;
    text-align: left;
  }

  .tutorial-form .el-form-item__content {
    margin-left: 0 !important;
  }

  .page-heading .el-button {
    padding: 8px 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/User2/TutorialEdit.vue